
import Vue from 'vue';
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';
import Status from '@/models/onboarding/Status';
import BoxTarget from '@/components/Box/Target/BoxTarget.vue';
import { checkPermission } from '@/api/utils';
import { addKpiCustomization } from '@/util/kpis';
import ProfileSurvey from '@/components/modals/SurveyModel.vue';
import RadarChartHome from './DetailedReport/components/RadarChartHome.vue';
import moment from 'moment';
import axios from 'axios';
import debounce from 'lodash/debounce';
import store from '@/store';

export default {
  // eslint-disable-next-line vue/no-unused-components
  components: { RadarChartHome, ProfileSurvey },
  data() {
    return {
      coronaBannerReadStatus: true,
      lastTimeStamp: Date.now(),
      lastDateUploaded: '',
      onboardingStatus: Status.DONE,
      overviewLoading: true,
      boxTargetLoading: true,
      // comparisionLoading: false,
      overViewKpiList: [],
      apiTimer: 0,
      lastModifiedJsonData: {},
      hasFetchedPref: false,
      apiTimeout: 0,
      canShowSurvey: false,
      renderAi: false
    };
  },
  computed: {
    ...mapGetters('tenant', ['hasResetAccount', 'isNewAccount']),
    ...mapState('overview', { overViewKpis: 'kpis' }),
    ...mapState('overview', [
      'regions',
      'districts',
      'stores',
      'groups',
      'SVs',
      'allTrends',
      'loadingApi'
    ]),
    ...mapState('user', ['kpiPreferences', 'kpiLabelValue', 'getLocale']),
    ...mapGetters('user', ['getProfile']),
    ...mapGetters('filter', [
      'getStoreCodesList',
      'getDaysOfWeekList',
      'getStartingPeriod',
      'getEndingPeriod',
      'getStartingCompared',
      'getEndingCompared',
      'getCustomCalenderState',
      'getCustom445DateRange'
    ]),

    // ...mapState('comparison', ['regions', 'districts', 'stores', 'groups', 'SVs']),
    ...mapState('target', ['targets', 'callTracker'])
  },
  watch: {
    kpiPreferences(newValue) {
      this.overViewKpiList = this.overViewKpis
        ? addKpiCustomization(this.overViewKpis)
        : [];
    },
    getStartingPeriod() {
      this.refreshAction();
    },
  },
  mounted() {
    const checkRenderAi = setInterval(() => {
      if (window['renderAi']) {
        this.renderAi = true;
        clearInterval(checkRenderAi);
      }
    }, 200);
    this.userDetailHandler()
    let surveyEmailAllowed = [
      'testinguser@flow-solutions.com',
      'shuhei@flow-insight.com'
    ];
    this.canShowSurvey =
      surveyEmailAllowed.indexOf(store.state.user.profile.email) > -1;
    Vue.prototype?.$mixpanel?.track('dashboard', {
      referrer: document.referrer
    });

  },
  beforeDestroy() {
  },
  // async created() {
  // const tenentIDD = localStorage.getItem('tenentID');
  // if(tenentIDD == 'hDnCfC55HomBqRbM5'
  // || tenentIDD == 'YEgaiFKJ3rt4d9q4g'
  // || tenentIDD == 'AmPwMfg3vK5cgWPQP'
  // || tenentIDD == '4TxrckSM8PrcEvfx9'
  // || tenentIDD == 'EGinM2LhX2gQmjtSz'
  // || tenentIDD == 'k2dizAofphvMY5Wzr'
  // || tenentIDD == 'PS2EaDKummN4GxNPP'
  // )//stripe
  // {
  //   localStorage.setItem('fidaMigrationCheck','true');
  // }
  // this.refreshPage()
  // },
  methods: {
    ...mapActions('comparison', ['fetchAllComparision']),
    ...mapActions('overview', ['fetchOverview', 'setDataByLocationFormatKey', 'loadingApiAction']),
    ...mapActions('target', ['fetchTargets', 'fetchTargetsSales']),
    ...mapActions('weather', ['getWeather']),
    ...mapActions('user', ['fetchKpiPreferences', 'userDetailHandler']),
   refreshAction: debounce(async function () {
      try {
        await this.fetchKpiPreferences();
        this.lastTimeStamp = Date.now();
        await this.refreshBoxTarget();
        await this.refreshOverview();
        this.lastDateUploaded = await this.calcLastTimeStamp();

        this.hasFetchedPref = true;
      } catch (e) {
        this.$q.notify({
          type: "negative",
          position: "top",
          message: `${e}`,
        });
      }
    }, 500),
    async refreshPage() {
      clearTimeout(this.apiTimer);
      this.apiTimer = setTimeout(this.refreshAction, 200);
    },
    // refreshPageComparision(val) {
    //   this.setDataByLocationFormatKey({ key: val.value });
    // },
    getParamsForOverview() {
      let stC = this.getStoreCodesList;
      if (!stC) {
        return;
      }
      return {
        startDate: this.getStartingPeriod,
        endDate: this.getEndingPeriod,
        compareStartDate: this.getStartingCompared,
        compareEndDate: this.getEndingCompared,
        storeCodes: stC,
        daysOfWeek: this.getDaysOfWeekList,
        useCustomCalender: this.getCustomCalenderState,
        groupByMetricKey: true,
        comparisonYKPIMetricKey: ([...this.kpiLabelValue][0] ?? {})?.value
        // kpis: this.customSort.join(',')
      };
    },
    async refreshOverview() {
      this.overviewLoading = true;
      try {
        
        let params = this.getParamsForOverview();
        if (params) {
          let str = JSON.stringify(params);

          params.trackLatest = { callerId: 'home', value: str };
         
          let isActionable = await this.fetchOverview(params);
          if (isActionable) {
            this.overViewKpiList = addKpiCustomization(this.overViewKpis);
            this.overviewLoading = false;
            setTimeout(() => {
              this.loadingApiAction(true);
            }, 5000);
            
          }
        } else {
          setTimeout(this.refreshOverview, 1000);
        }
      } catch (e) {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          message: `${e}`
        });
      }
    },
    async refreshBoxTarget() {
      this.boxTargetLoading = true;
      try {
        let stC = this.getStoreCodesList;
        if (!stC) {
          setTimeout(this.refreshBoxTarget, 1000);
          return;
        }
        let params = {
          startDate: this.getStartingPeriod,
          endDate: this.getEndingPeriod,
          kpiTypes: ['sls', 'st'],
          storeCodes: stC.split(',')
        };
        let str = JSON.stringify(params);
        params.trackLatest = { callerId: 'home', value: str };
        await this.fetchTargets(params);
        this.boxTargetLoading = false;
      } catch (error) {
        this.$q.notify({
          type: 'negative',
          position: 'top',
          message: `${error}`
        });
      } finally {
        this.boxTargetLoading = false;
      }
    },
    async calcLastTimeStamp() {
      const apiUrl =
        'https://flow-public-resource.s3.ap-northeast-1.amazonaws.com/data/LastModifiedStore.json';
      const config = {
        headers: {
          Authorization: ''
        }
      };
      return JSON.stringify(await axios.get(apiUrl, config));
    }
  }
};
